import { useEffect, useState } from 'react';
import { fetchJsonCached } from '../lib/settingsCache';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Charter / excursion companies.
 *
 * Single source of truth = the sellers created in Admin -> Tours & Charters.
 * Anything added there appears automatically wherever this hook is used
 * (e.g. the EXCURSION COMPANIES footer menu). Nothing is hardcoded.
 */
export const useCharterCompanies = () => {
  const [state, setState] = useState({ companies: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;

    const fetchCompanies = async () => {
      try {
        const data = await fetchJsonCached(`${API_URL}/api/public/tours-charters/sellers`);
        if (cancelled) return;
        const companies = (Array.isArray(data) ? data : [])
          .filter((c) => c && c.slug && c.name)
          // public_slug is the legacy (indexed) URL when the company has one
          .map((c) => ({ ...c, public_slug: c.public_slug || c.legacy_slug || c.slug }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setState({ companies, loading: false, error: null });
      } catch (error) {
        if (!cancelled) setState({ companies: [], loading: false, error });
      }
    };

    fetchCompanies();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};

export default useCharterCompanies;
